import { css } from '@emotion/react';
import { ScheduleType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule.pb';
import { ScopedSingleLocationFilterMenu } from '@frontend/location-filter-menu';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { useFormField } from '@frontend/design-system';
import { DirectAvailabilityCheck } from '../../components/DirectAvailabilityCheck';
import { ScheduleBanner } from '../../components/ScheduleBanner';
import { scheduleDirectAvailabilityBannerText } from '../../constants';
import { ExceptionsV3Page } from '../ManagePractitionersV3';

const { officeHoursDirectAvailabilityTitle, officeHoursDirectAvailabilityMessage } =
  scheduleDirectAvailabilityBannerText;
export const OfficeHoursExceptionsV3 = () => {
  const { selectedLocationIds, isSingleTypeScope, getScopeName } = useAppScopeStore();
  const selectedLocationField = useFormField({ type: 'checklist', value: [selectedLocationIds[0]] }, [
    selectedLocationIds,
  ]);

  const hasMultipleLocations = !isSingleTypeScope;

  const locationId = hasMultipleLocations ? selectedLocationField.value[0] : selectedLocationIds[0];

  return (
    <>
      {hasMultipleLocations && (
        <>
          <ScopedSingleLocationFilterMenu field={selectedLocationField} css={locationDropdownStyle} />
          <DirectAvailabilityCheck locationId={selectedLocationField.value[0]} css={{ marginTop: theme.spacing(2) }}>
            <ScheduleBanner
              fullWidth
              title={officeHoursDirectAvailabilityTitle}
              message={officeHoursDirectAvailabilityMessage}
            />
          </DirectAvailabilityCheck>
        </>
      )}
      <ExceptionsV3Page
        locationId={locationId}
        entityId={locationId}
        entityName={getScopeName(locationId)}
        entityType={ScheduleType.LOCATION}
      />
    </>
  );
};

const locationDropdownStyle = css({
  marginTop: theme.spacing(4),
  background: theme.colors.primary50,
  color: theme.colors.white,
  p: { color: theme.colors.white },
});
